document.addEventListener('DOMContentLoaded', function () {
  initTableOfContents();
  initStickySidebar();
});

/* ===========================
   BLOG TABLE OF CONTENTS
   Builds the TOC from real DOM nodes (no innerHTML string
   concatenation, so heading text can never be reinterpreted
   as HTML) and highlights the active section using
   IntersectionObserver instead of a scroll listener.
=========================== */
function initTableOfContents() {
  const content = document.getElementById('BlogContent');
  const toc = document.getElementById('BlogTOC');

  if (!content || !toc) return;

  const headings = Array.from(content.querySelectorAll('h2'));

  if (!headings.length) {
    toc.innerHTML = '<p>No sections available</p>';
    return;
  }

  const list = document.createElement('ul');

  headings.forEach(function (heading, index) {
    if (!heading.id) heading.id = 'section-' + index;

    const li = document.createElement('li');
    li.className = heading.tagName.toLowerCase();

    const a = document.createElement('a');
    a.href = '#' + heading.id;
    a.textContent = heading.textContent;

    li.appendChild(a);
    list.appendChild(li);
  });

  toc.appendChild(list);

  const linksById = new Map(
    Array.from(toc.querySelectorAll('a')).map(function (a) {
      return [a.getAttribute('href').slice(1), a];
    })
  );

  const setActive = function (id) {
    linksById.forEach(function (link) {
      link.classList.toggle('active', link === linksById.get(id));
    });
  };

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) setActive(entry.target.id);
      });
    },
    { rootMargin: '-150px 0px -70% 0px', threshold: 0 }
  );

  headings.forEach(function (heading) {
    observer.observe(heading);
  });
}

/* ===========================
   STICKY SIDEBAR OFFSET
   The sidebar itself is stuck via CSS `position: sticky`
   (see .article-sidebar__inner) — the browser handles the
   stick/release entirely on its own, bounded by the height of
   the .article-sidebar grid cell, so it can never overlap the
   comments/footer the way a manually-computed scroll position did.

   The only thing JS needs to do is keep the `--article-sticky-offset`
   custom property in sync with the real header height, since some
   themes shrink the header once you start scrolling. A ResizeObserver
   only fires when the header actually changes size, so this adds no
   scroll listener at all.
=========================== */
function initStickySidebar() {
  const header = document.querySelector('.header-wrapper');
  const GAP = 24;

  function setOffset() {
    const headerHeight = header ? header.offsetHeight : 80;
    document.documentElement.style.setProperty(
      '--article-sticky-offset',
      (headerHeight + GAP) + 'px'
    );
  }

  setOffset();

  if (header && 'ResizeObserver' in window) {
    new ResizeObserver(setOffset).observe(header);
  } else {
    window.addEventListener('resize', setOffset);
  }
}